import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateFloorplanPlacement } from '../services/postCreateFloorplanPlacement.service';

export const createFloorplanPlacement = createAsyncThunk(
  'floorplans/createFloorplanPlacement',
  async (
    { projectId, filePermissionId, filePermissionIds, floorplanId, x, y },
    { rejectWithValue }
  ) => {
    try {
      const body = {
        floorplanId,
        x,
        y,
        ...(filePermissionIds ? { filePermissionIds } : { filePermissionId }),
      };
      const response = await postCreateFloorplanPlacement(projectId, body);
      return response.placements;
    } catch (err) {
      return rejectWithValue({ message: err.message });
    }
  }
);
